<template>
    <div>
        <el-breadcrumb separator-class="uil uil-angle-right-b m-breadcrum">
            <el-breadcrumb-item :to="{ name: 'Dashboard' }"><i class="uil uil-home"></i></el-breadcrumb-item>
            <el-breadcrumb-item to="/settings">Company Settings</el-breadcrumb-item>
            <el-breadcrumb-item >Wireless Support Sync</el-breadcrumb-item>
        </el-breadcrumb>

        <WirelessSupportSyncSettings />
    </div>
</template>
<script>
import WirelessSupportSyncSettings from '@/views/Settings/WirelessSupportSync/components/WirelessSupportSyncSettings';

export default{
    name: "WirelessSupportSync",
    components:{
        WirelessSupportSyncSettings
    },
}
</script>